<template>
    <el-table
        :data="signInTable"
        ref="SignInTable"
        border
        class="performanceSignInTable"
        :height="320"
    >
        <el-table-column
            label="商品行号"
            prop="lineNo"
            show-overflow-tooltip
            align="center"
            width="100px"
        ></el-table-column>
        <el-table-column
            label="商品编码"
            prop="itemCode"
            align="center"
            show-overflow-tooltip
            width="150px"
        ></el-table-column>
        <el-table-column
            label="商品名称"
            prop="itemName"
            align="center"
            show-overflow-tooltip
            width="300px"
        ></el-table-column>
        <el-table-column
            label="商品状态"
            prop="itemStatusName"
            align="center"
            show-overflow-tooltip
            width="100px"
        ></el-table-column>
        <el-table-column
            v-if="rowData.sourceSystem === 'BELLE-WBKH'"
            label="上游商品行号"
            align="center"
            prop="upperLineNo"
            show-overflow-tooltip
            width="190px"
        ></el-table-column>
        <el-table-column
            label="正品"
            align="center"
            prop="realReceive"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            label="污染"
            align="center"
            prop="mildewPolluteCount"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="破损"
            align="center"
            prop="packageDamagedCount"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="短少"
            align="center"
            prop="stockoutCount"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="拒收"
            align="center"
            prop="rejectQty"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="备注" width="120px" align="center">
            <template slot-scope="scope">
                <el-tooltip
                    placement="top"
                    :open-delay="500"
                    :content="scope.row.signRemark"
                    :disabled="isShowTooltip"
                >
                    <span>
                        <el-input
                            v-model.trim="scope.row.signRemark"
                            @input="signRemarkChange(scope.row)"
                            style="width: 100%"
                            class="customTableColumnInput"
                        ></el-input>
                    </span>
                </el-tooltip>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { OPERATE_TYPE } from '../utils/constant.js';
export default {
    name: 'signInTable',
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        tableDataList: {
            type: Array,
            default () {
                return [];
            }
        },
        kaType: {
            type: String,
            default: ''
        },
        operateType: { // 操作类别
            type: String,
            default: ''
        }
    },
    data () {
        return {
            signInTable: [],
            isShowTooltip: true
        };
    },
    methods: {
        signRemarkChange (row) {
            this.isShowTooltip = true;
            if (row.signRemark) {
                this.isShowTooltip = false;
            }
        },
        /**
         * @description 初始化回单签收表格数据
         * 签收改拒收，将所有数量全部赋给拒收，其余都为0
         */
        initTableData () {
            this.signInTable = JSON.parse(JSON.stringify(this.tableDataList));
            this.signInTable.forEach(v => {
                v.realReceive = 0;
                v.stockoutCount = 0;
                v.mildewPolluteCount = 0;
                v.packageDamagedCount = 0;
                v.rejectQty = v.realDeliverCount;
            });
        },

        /**
         * @description 组装数据
         */
        formatReqParams () {
            const params = this.signInTable.map(v => {
                return {
                    abnormalCount: sum([v.mildewPolluteCount, v.packageDamagedCount, v.stockoutCount, v.rejectQty]) || 0, // 总异常数量
                    id: v.id, // 商品id
                    custItemCode: v.custItemCode, // 客户商品编码
                    itemCode: v.itemCode, // 商品编码
                    itemName: v.itemName, // 商品名称
                    itemStatus: v.itemStatus, // 商品状态
                    itemSuiteCode: v.itemSuiteCode, // 套机编码
                    lineNo: v.lineNo, // 商品行号
                    mildewPolluteCount: v.mildewPolluteCount || 0, // 霉变污染
                    packageDamagedCount: v.packageDamagedCount || 0, // 包装破损
                    stockoutCount: v.stockoutCount || 0, // 货物短少
                    rejectQty: v.rejectQty || 0, // 拒收数量
                    realDeliverCount: v.realDeliverCount || 0, // 实发数量
                    realReceiveCount: sum([v.realReceive, v.packageDamagedCount, v.mildewPolluteCount]) || 0, // 实收数量
                    realReceive: v.realReceive || 0, // 正品数量
                    signRemark: v.signRemark, // 备注
                    taskNo: this.rowData.taskNo, // 运输单号
                    upperLineNo: v.upperLineNo, // 上游商品行号
                    version: v.version || 0
                };
            });
            return params;
        },

        /**
         * @description 校验正品数量是否大于0，拒收确认时，备注必填
         */
        validateDataIsTrue () {
            return new Promise((resolve, reject) => {
                const flag = this.signInTable.every(v => v.realReceive >= 0); // 正品是否大于等于0
                const signRemarkIsNull = this.signInTable.some(v => !v.signRemark); // 备注是否为空（拒收确认时，备注必填）
                if (!flag) {
                    reject(new Error('正品数量不能为负数！'));
                } else if (this.operateType === OPERATE_TYPE.REJECT_COMFIRM && signRemarkIsNull) {
                    reject(new Error('备注不能为空！'));
                } else {
                    resolve(this.formatReqParams());
                }
            });
        }
    },
    watch: {
        tableDataList: {
            handler (val) {
                this.initTableData();
            },
            deep: true,
            immediate: true
        }
    }

};
</script>
<style lang="less">
.performanceSignInTable {
    .customTableColumnInput {
        .el-input__inner {
            border-color: transparent;
            cursor: default;
            &:focus {
                border-color: #c3c7c7;
            }
        }
    }
    .el-input {
        vertical-align: middle;
    }
    .notEdit {
        height: 28px;
        line-height: 28px;
    }
}
</style>
